import styled from "styled-components";
import { Colors } from "../../config/Constants";
import TableBody from "./TableBody";
import TableHeader from "./TableHeader";

interface Props {
  columns: (
    | {
        path: string;
        label: string | null;
        key: string | null;
        // eslint-disable-next-line no-empty-pattern
        content: ({}) => Element | null;
      }
    | any
  )[];
  data: {}[];
  onRowClick?: (item: any) => void;
  isTableDataLoading?: boolean;
  showHighlight?: boolean;
}

const Table = ({
  columns,
  data,
  onRowClick,
  isTableDataLoading,
  showHighlight = false,
}: Props) => {
  return (
    <TableWrapper>
      <StyledTable>
        <TableHeader columns={columns} />
        <TableBody
          isTableDataLoading={isTableDataLoading}
          columns={columns}
          data={data}
          onRowClick={onRowClick}
          showHighlight={showHighlight}
        />
      </StyledTable>
    </TableWrapper>
  );
};

const TableWrapper = styled.div`
  overflow-x: auto;
  &::-webkit-scrollbar {
    width: 0.875rem;
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar-thumb {
    height: 3.625rem;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 0.625rem;
    background-color: #000000;
  }
`;

const StyledTable = styled.table`
  width: 100%;
  white-space: nowrap;
  border-collapse: collapse;
  border-bottom: 1px solid ${Colors.solitude};
`;

export default Table;
